export const BAYI_HOST = 'bayi.unmak.tech';
export const SERVIS_HOST = 'servis.unmak.com';

export const isBayiPanel = () => {
  if (typeof window === 'undefined') return false;
  return window.location.hostname === BAYI_HOST;
};

export const isServisPanel = () => {
  if (typeof window === 'undefined') return false;
  return window.location.hostname === SERVIS_HOST;
};

export const getLoginTitle = () =>
  isBayiPanel() ? 'Bayi Yönetim Sistemi' : 'SM Yönetim Sistemi';

export const getPostLoginPath = (rol) => {
  const role = String(rol || '').toLowerCase();
  if (role === 'superadmin') return '/test-panel';
  if (role === 'review-app') return '/review-app';
  if (role === 'tech-person') return '/teknisyen';
  if (role === 'sevkiyat') return '/sevkiyat';
  if (role === 'bayi') return '/';
  return '/';
};
